import StatusChip from './StatusChip';

import { JUDGEMENTS } from '../../i18n/el';

/**
 * Η καταγεγραμμένη εκτίμηση συνάφειας ως σήμα (ΛΑ-17, Απόφαση D16).
 *
 * **Πάντα με εικονίδιο και πάντα με κείμενο**, ποτέ μόνο χρώμα: οι τρεις βαθμίδες
 * είναι διατεταγμένες, και ο χρήστης που δεν διακρίνει τους τόνους πρέπει να τις
 * ξεχωρίζει το ίδιο καλά (ΜΛΑ-11, WCAG 1.4.1).
 *
 * **Κοινό συστατικό και όχι τοπικό.** Ζούσε μέσα στον πίνακα κρίσεων του πόρου, που
 * ήταν η μόνη του χρήση. Μετακόμισε εδώ όταν οι τρεις βαθμίδες απέκτησαν διακριτά
 * χρώματα: από εκείνη τη στιγμή είναι **σχεδιαστική σύμβαση** —«υψηλή = teal, μεσαία
 * = μωβ, χαμηλή = πορτοκαλί»— και μια σύμβαση που ζει σε ένα συστατικό δεν είναι
 * σύμβαση, είναι λεπτομέρειά του. Ταυτόχρονα μπαίνει στη βιβλιοθήκη συστατικών, όπου
 * γίνονται οι έλεγχοι αντίθεσης και πλάτους.
 */
const RELEVANCE_CHIP = {
    high: { tone: 'teal', icon: 'fa-solid fa-circle-check' },
    medium: { tone: 'purple', icon: 'fa-solid fa-circle-half-stroke' },
    // Πορτοκαλί και όχι ουδέτερο. Το ουδέτερο γκρι διαβαζόταν ως **απουσία
    // εκτίμησης** και όχι ως χαμηλή: οι τρεις βαθμίδες πρέπει να ξεχωρίζουν με το
    // μάτι, και δύο από τις τρεις ξεχώριζαν.
    //
    // Πορτοκαλί και όχι κόκκινο, που ήταν η δεύτερη επιλογή: το κόκκινο σημαίνει
    // σφάλμα σε ολόκληρη την εφαρμογή, και η χαμηλή συνάφεια δεν είναι σφάλμα —
    // είναι έγκυρη ανθρώπινη κρίση, καταγεγραμμένη από άνθρωπο. Ένα χρώμα με δύο
    // νοήματα είναι το ίδιο πρόβλημα με μια λέξη που σημαίνει δύο πράγματα.
    low: { tone: 'warning', icon: 'fa-solid fa-circle-minus' }
};

export default function RelevanceChip({ value, ...rest }) {
    const chip = RELEVANCE_CHIP[value] ?? RELEVANCE_CHIP.low;

    return (
        <StatusChip icon={chip.icon} tone={chip.tone} {...rest}>
            {JUDGEMENTS.relevance[value] ?? value}
        </StatusChip>
    );
}
